module.exports = __webpack_public_path__ + "img/ztpx_banner.4aacb378.png";